export default function animatedNumberPanel() {
    Alpine.data('numberAnimation', () => ({
        increase: '',
        prefix: '',
        suffix: '',
        startVal: '',
        targetValue: '',
        currentValue: '',
        displayValue: '',
        passValues(prefix, suffix, startVal, value, increase) {
            this.prefix = prefix;
            this.suffix = suffix;
            this.startVal = parseFloat(startVal);
            this.targetValue = parseFloat(value);
            this.increase = increase;
            this.currentValue = this.startVal;

            this.updateDisplayValue();
        },
        resetValues() {
            this.displayValue = this.startVal
            this.currentValue = this.startVal
        },
        animateNumbers() {
            const startTime = performance.now();
            const startValue = this.currentValue;
            const endValue = this.targetValue;
            const duration = 2000;

            const animate = (currentTime) => {
                const elapsedTime = currentTime - startTime;
                let progress = elapsedTime / duration;

                progress = 1 - Math.pow(1 - progress, 5);

                if (this.increase.includes('up')) {
                    this.currentValue = startValue + (endValue - startValue) * progress;
                } else if (this.increase.includes('down')) {
                    this.currentValue = startValue - (startValue - endValue) * progress;
                }

                this.updateDisplayValue();

                if (elapsedTime < duration) {
                    requestAnimationFrame(animate);
                } else {
                    this.currentValue = endValue;
                    this.updateDisplayValue();
                }
            };

            requestAnimationFrame(animate);
        },
        updateDisplayValue() {
            const isWholeNumber = Number.isInteger(this.targetValue);

            if (isWholeNumber) {
                this.displayValue = `${Math.round(this.currentValue).toLocaleString()}`;
            } else {
                this.displayValue = `${parseFloat(this.currentValue.toFixed(1)).toLocaleString()}`;
            }
        }
    }))
}